import { UserIcon } from "@heroicons/react/24/solid";
import { PublicUserOrganization } from "../../../../../../__generated__/graphql";
import useSignedUrlToGetFile from "../../../../../../hooks/useSignedUrlToGetFile";
import { organizationTypeToName } from "../../../../../../lib/utils";

export default function CollaboratorCard({
  userOrganization,
  onClick,
}: {
  userOrganization: PublicUserOrganization;
  onClick: () => void;
}) {
  const { data: signedUrlData, loading: isLoadingSignedUrl } =
    useSignedUrlToGetFile(userOrganization?.avatarBucketKey);

  const hasAvatar = !isLoadingSignedUrl && signedUrlData?.signedUrlToGetFile;

  return (
    <div
      className="w-52 h-52 bg-card rounded-md cursor-pointer relative hover:translate-y-[-2px] transition-all duration-300"
      onClick={onClick}
    >
      {hasAvatar ? (
        <img
          src={signedUrlData.signedUrlToGetFile ?? ""}
          className="w-full h-full object-cover border border-input rounded-md"
        />
      ) : (
        <div className="w-full h-full flex items-center justify-center">
          <UserIcon className="w-1/2 h-1/2 object-cover border border-input rounded-md text-tertiary" />
        </div>
      )}

      <div className="p-2 absolute bottom-0 h-24 w-full bg-gradient-to-b from-transparent to-black rounded-b-md">
        <div className="flex flex-col h-full justify-end">
          {userOrganization.jobTitle ? (
            <div className="text-accent text-xs uppercase break-words">
              {userOrganization.jobTitle}
            </div>
          ) : (
            <div className="text-accent text-xs uppercase break-words">
              {organizationTypeToName[userOrganization.organizationType]}
            </div>
          )}

          <div className="font-bold text-primary truncate">
            {userOrganization.name}
          </div>
        </div>
      </div>
    </div>
  );
}
